// Standalone enum (no imports) so block + components can use it without a circular
// import / temporal-dead-zone issue at module-eval time.
export enum ProjectListNodeType {
  text = 'text',
  calendarEvent = 'calendarEvent',
  vendors = 'vendors',
  vccItems = 'vccItems',
}
